import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { site, office, hours, footerLegal } from "@/config/site";
import { services } from "@/content/services";
import { Logo } from "@/components/layout/Header";

const Col = ({ title, links }) => (
  <div>
    <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">{title}</p>
    <ul className="space-y-2.5">
      {links.map((l) => <li key={l.to}><Link to={l.to} className="text-sm text-slate-700 hover:text-teal">{l.label}</Link></li>)}
    </ul>
  </div>
);

export const Footer = () => (
  <footer className="border-t border-line bg-white" data-testid="site-footer">
    <div className="container-x py-16 lg:py-20">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo className="h-9" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-600">{site.promise}</p>
          <ul className="mt-8 space-y-3 text-sm text-slate-700">
            <li className="flex gap-3"><Mail className="mt-0.5 h-4 w-4 flex-none text-teal" aria-hidden /><a href={`mailto:${site.email}`} className="hover:text-teal" data-testid="footer-email">{site.email}</a></li>
            <li className="flex gap-3"><Phone className="mt-0.5 h-4 w-4 flex-none text-teal" aria-hidden /><span>{site.phones.map((p, i) => <a key={p} href={`tel:${p.replace(/\s/g, "")}`} className="hover:text-teal">{p}{i < site.phones.length - 1 ? " · " : ""}</a>)}</span></li>
            <li className="flex gap-3"><MapPin className="mt-0.5 h-4 w-4 flex-none text-teal" aria-hidden /><span>{office.addressLine}</span></li>
            {hours.open24Hours && <li className="flex gap-3"><Clock className="mt-0.5 h-4 w-4 flex-none text-teal" aria-hidden /><span data-testid="footer-hours">{hours.label}</span></li>}
          </ul>
        </div>
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-4 lg:col-span-8">
          <Col title="Services" links={[...services.slice(0, 6).map((s) => ({ label: s.title.replace(" and ", " & "), to: `/services/${s.slug}` })), { label: "All services", to: "/services" }]} />
          <Col title="Company" links={[{ label: "About", to: "/about" }, { label: "Methodology", to: "/methodology" }, { label: "How It Works", to: "/how-it-works" }, { label: "Industries", to: "/industries" }, { label: "Partnerships", to: "/partnerships" }, { label: "Contact", to: "/contact" }]} />
          <Col title="Explore" links={[{ label: "Pricing", to: "/pricing" }, { label: "Customer Reviews", to: "/reviews" }, { label: "Sample Report", to: "/sample-report" }, { label: "Compliance Hub", to: "/compliance" }, { label: "FAQ", to: "/faq" }, { label: "Request an Assessment", to: "/request-assessment" }]} />
          <Col title="Legal" links={footerLegal} />
        </div>
      </div>
      <div className="mt-16 border-t border-line pt-8 text-sm leading-relaxed text-slate-500">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} {site.name}. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
